import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'deliverState',
})
export class DeliverState implements PipeTransform {
  statesArr = ['Created', 'Draft', 'AddingItems', 'ArrangingPayment', 'PaymentAuthorized', 'PaymentSettled'];
  transform(value: string): string {
    return this.statesArr.find(item => item === value) ? '未发货' : '已发货';
  }
}
